import { inject } from '@angular/core';
import { AppSettingsQuery } from 'chronos-shared';

export const resourceConfigurationGuard = () => {
  const appSettingsQuery: AppSettingsQuery = inject(AppSettingsQuery);
  return appSettingsQuery.isEnableResourceConfigurationReadOnly$ || appSettingsQuery.isEnableResourceConfiguration$;
};
